import type { QueryParams } from '@freelancer/ui/link';

export enum SplitButtonOptionPosition {
  TOP = 'top',
  BOTTOM = 'bottom',
}

export type SplitButtonOptionIconName =
  | 'ui-archive'
  | 'ui-bin'
  | 'ui-check-in-circle-v2'
  | 'ui-close'
  | 'ui-close-alt'
  | 'ui-lock'
  | 'ui-reveal'
  | 'ui-share'
  | 'ui-edit';

export interface SplitButtonOption {
  displayText: string;
  newTab?: boolean; // flag to open in a new tab for desktop
  link?: string;
  linkQueryParams?: QueryParams;
  iconName?: SplitButtonOptionIconName;
}
